export function formatConnectCode(code?: string | null) {
  if (!code) {
    return "";
  }
  if (code.length <= 4) {
    return code.toUpperCase();
  }
  return code
    .replace(/-/g, "")
    .slice(0, 8)
    .replace(/^(\w{4})(\w.*)?$/, "$1-$2")
    .toUpperCase();
}
